<template>
  <ButtonTertiary
    :data-test="data_test"
    @click="(event) => togglePopover(event)"
  >
    <FontAwesomeIcon
      v-if="!loading"
      :icon="['far', 'gear']"
      size="lg"
    />
    <FontAwesomeIcon
      v-else
      :icon="['far', 'spinner']"
      size="lg"
      spin
    />
  </ButtonTertiary>
  <Popover
    ref="popover"
    :pt="{ content: '!p-0 !m-0' }"
  >
    <div
      class="flex flex-col gap-1 py-2"
      @click="closePopover"
    >
      <slot />
    </div>
  </Popover>
</template>

<script setup>
import { defineProps, ref } from 'vue';

defineProps({
  data_test: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const popover = ref(null);

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const closePopover = () => {
  popover?.value?.toggle(false);
};
</script>
